import TechnicalStatusTable from "./technical-status-table.vue";

export default TechnicalStatusTable;



// WEBPACK FOOTER //
// ./src/components/_dashboard/technical-status/table/index.js